import { render, staticRenderFns } from "./BgTitle.vue?vue&type=template&id=316f1673&scoped=true&"
import script from "./BgTitle.vue?vue&type=script&lang=js&"
export * from "./BgTitle.vue?vue&type=script&lang=js&"
import style0 from "./BgTitle.vue?vue&type=style&index=0&id=316f1673&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f1673",
  null
  
)

export default component.exports